import React, {useState, useEffect, useContext, useRef} from 'react'
import Header from "../components/header/Header";
import '../components/css/program.css'
import { useNavigate } from "react-router-dom";

import GroupEditModal from '../components/Modals/GroupEditModal';
import { DayPicker  } from 'react-day-picker';
import da from "date-fns/locale/da";
import close from '../images/close.png'
import searchIcon from '../images/search-26233.png'
import calendar from '../images/Icon-Calendar.png'
import { keyContext } from "../components/KeyContext";
import FilmWidget from '../components/FilmWidgets'
import trans from '../images/trans.png'
import doublearrow from '../images/double-arrow.png'
import moment from 'moment'
import small_square from '../images/small_square.svg'
import small_checkmark from '../images/small_checkmark.svg'
import alertIcon from '../images/Icon-Altert_Small.png'
import iconCross from '../images/Icon-Cross.png'
// import { format, set } from 'date-fns'
import DatePicker from '../components/DatePicker/DatePicker';
import ScaleLoader  from 'react-spinners/ScaleLoader';
import OrgSelect from '../components/OrgSelect';
import WaitingModal from '../components/Modals/WaitingModal';
import semiCheckbox from '../images/Semi-checked.svg';
 import NoteModal from '../components/Modals/NoteModal';
import EditChosenBox from '../components/Modals/EditChosenBox';
import ErrorModal from '../components/Modals/ErrorModal';
import ManEventErrorModal from '../components/Modals/ManEventErrorModal';

import CommitModal from '../components/Modals/CommitModal';

function Program() {
              
const { setSelectAllFilmAtOnce, selectedDate, setLeftMargin, setArrTypes ,  allTicketTypes, setAllTicketTypes,     modalOpen ,moviesSelected,setMoviesSelected ,    selectAllFilmAtOnce,deletebtnclk, setDeletebtnclk, dateChosen, anyMovieSelected,setAnyMovieSelected, divOpened, setSelectedDate,allOne,allzero,savebtnclk, setSavebtnclk, setalertEvents,eventEdit,eventsChanged , eventSaveObj, setEventSaveObj,showErrorModal,errorNo, errorText,    setShowErrorModal, setErrorNo, setErrorText, showFilm, setShowFilm, showDropdown, setShowDropdown, clickedMovieDiv,waitingModal, setWaitingModal,errorStatus,errorType,setErrorStatus,setErrorType,setApiLoader,commitModal, setCommitModal,apiLoader, logOut,changes,changesLeft,setChangesLeft,eventPushCheck,setProgrammedDates,setEventErrorModal,eventErrorModal} = useContext(keyContext)

  let flag = false // flag determines overlap text when api takes more than 2 seconds to reply
  const windowHeight = window.innerHeight  
  const [dragging, setdragging] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const key = sessionStorage.getItem("key");  
  const allowOverlap = localStorage.getItem('allow_overlap')
  const [isloading, setIsLoading] = useState(true);
  const [preciseFilm, setPreciseFilm] = useState();
  const [searchPrecise, setSearchPrecise] = useState(false);
  const [divOverlap, setDivOverlap] = useState(false);
  const navigate = useNavigate();
  const [zeroPriceError, setZeroPriceError] = useState();

  const [manEventErrortext, setManEventErrortext] = useState();
    let default_filmID = sessionStorage.getItem('default-filmID')

  // const divHeight = document.getElementById('tes').getBoundingClientRect().height
  function handlePreciseSearch () {
    setSearchPrecise((current) => !current)
  }

 let ge = sessionStorage.getItem('programOrg')

 let orgSelect = ge && ge.split(" ")[ge.split(" ").length - 1]

  useEffect(() => {
    document.title = "Programlægning - ebillet_admin";
   
  }, []);


  //----------preventing body scroll when modal is open------------- 
  if(modalOpen === true) {
    document.body.style.overflowY = 'hidden'
  } else document.body.style.overflowY= ''

  const override: CSSProperties = {
    display: "block",
    position: "absolute",
    top: "30%",
    left: "50%",
    margin: "0 auto",
    textAlign: "center",
    borderColor: "#982f2f",
    transform: "translate(-50%, -50%)",
  };

  const disabledDays = [{ from: new Date(2022, 0, 1), to:  moment().subtract(1, 'day').toDate() }] ;
  const [modalShown, toggleModal] = useState(false);
  const [overlapModal, setOverlapModal] = useState(false)
 
  const [widgets, setWidgets] = useState([])
  const [showTime,setShowTime] = useState(false)
  const [startTime,setStartTime] = useState([])
  const [draggedFilm, setDraggedFilm] = useState('')
  const [error,setError] = useState(false)
  const [grpEditArr, setGrpEditArr] = useState([])
  // const [programmed,setProgrammed] = useState()
  const [editedEvents, setEditedEvents] = useState([])
  const [filmWidth, setFilmWidth] = useState()
  const [showG,setShowG] = useState(false)
  const [editChosen, setEditChosen] = useState(false)
  const [copyChosen, setCopyChosen] = useState(false)
  const [original_events, setOriginal_events] = useState([]);

  // const [xAxis,setXAxis] = useState([])
  // const [yAxis, setYAxis] = useState([])
  // const [existingYaxis,setExistingYaxis] = useState([])
  // const [showStartTimeArr, setShowStartTimeArr] = useState([])
  // const [showEndTimeArr, setShowEndTimeArr] = useState([])
  const [saveFilmEdit, setSaveFilmEdit] = useState(false);
  const [newDraggedFilm, setNewDraggedFilm] = useState()
  const [draggedMovieId,setDraggedMovieId]  = useState()
  const [openCalendar,setOpenCalendar] = useState(false)
  const [startDatoCal,setStartDatoCal] = useState(false)
  const [endDatoCal,setEndDatoCal] = useState(false) 
  const [dragStarted, setDragStarted] = useState(false)
  const [dragEnded, setDragEnded] = useState(false)
  const [startDate,setStartDate] = useState(new Date()) 
  const [endDate, setEndDate] = useState('') 
  let start_dato = moment(startDate).format('DD-MM-YYYY')
  let end_dato =  endDate ?   moment(endDate).format('DD-MM-YYYY') : 'Tilføj dato(er)'
 
  const [month, setMonth] = useState(); 

  const [x, setX ] = useState(0)
  const [y, setY ] = useState(0)


useEffect(() => {
  setStartDate(selectedDate)
},[selectedDate])

useEffect(() => {
  setMonth(selectedDate)
},[selectedDate])


function asFirstDate() {
  setEndDate(startDate)
  setEndDatoCal(false)
}

//------ the value from search input
  const [q, setQ] = useState("");

  // const [copyStartdate, setCopyStartdate] = useState()
  // const [copyEnddate,setCopyEnddate] = useState()

  const [allMovies, setAllMovies]     = useState([]);
  const [numberOfSal, setnumberOfSal] = useState([]);
  const [allEvents, setAllEvents]     = useState([]);
  const [eventsEdit, setEventsEdit]   = useState([])
  const [filmSearch, setFilmSearch ]  = useState([])
  // const [eventEdited, setEventEdited] = useState(false)
  const [copied, setCopied]           = useState(false);
  //----- events variables declarations --------------

  const [eventDelete, setEventDelete] = useState(false);

  //----------api call for data-----------
  useEffect(() => {
    if(orgSelect || default_filmID) { 
      setIsLoading(true)
      setError(false)
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getprogram?Key=${key}&strOrganizers=${default_filmID ? default_filmID : orgSelect}`;
    if(key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
     .then(res =>  {
   
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => {
        
            setIsLoading(false)

       
              if(result?.Message) {
                setError(true)
              }
                else {
             
        setAllMovies(result.Movies)
        setnumberOfSal(result.Locations)
        setAllEvents(result.Events)
        setOriginal_events(result.Events)
        setEventsEdit(result.EventsEdit && result.EventsEdit)
        setFilmSearch(result.Movies)
        setAllTicketTypes(result.TicketTypes)
        setArrTypes(result.ArrTypes)
        
        setError(false)
      }
   
      })
       
    }
  }
  }, [key,orgSelect,dateChosen,setArrTypes, setAllTicketTypes,copied,deletebtnclk,savebtnclk,eventDelete])
  
 

      useEffect(() => {
         let dd = []
     allEvents.map((e) =>  { 
    
      dd.push(moment(e.start).format('YYYY-MM-DD'))
     
    })
     setProgrammedDates(dd) 
   },[allEvents, setProgrammedDates]);


  //  useEffect(() => {
     //setProgrammedDates(dd) 
  //  },[dd]);

//------ api call for movie search ------------
 useEffect(() => {
  const endpoint1 = `https://biograf.ebillet.dk/systemnative/report.asmx/man_movie_search?Key=${key}&search=${'%25'+q+'%25'}`;
  const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_movie_search?Key=${key}&search=${q}`;
    if(key && q ) {
   
    

      fetch(searchPrecise === true ? endpoint : endpoint1, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
      .then(res =>  { 
    
        if(res.status === 200) {
          return  res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 
             
         
              if(result) { 
                  // q.length && 
                   setFilmSearch(result)
              }
              else {
                 setShowErrorModal(true)
                 setErrorNo(result.Result)
                 setErrorText(result.ErrorDescription)
              }
         
      
        
      })
     
    }
 },[key,q,searchPrecise])


  const [aclicked,setAclicked] = useState(false) 
  const [bclicked,setBclicked] = useState(false)
  const [cclicked,setCclicked] = useState(false)
  const [dclicked,setDclicked] = useState(false)
  const [eclicked,setEclicked] = useState(false)
  const [a2clicked,setA2clicked] = useState(false) 
  const [b2clicked,setB2clicked] = useState(false)
  const [c2clicked,setC2clicked] = useState(false)
  const [d2clicked,setD2clicked] = useState(false)
  const [e2clicked,setE2clicked] = useState(false)

 const [internetorderflag, setInternetorderflag] = useState()
 const [internetsellflag,   setInternetsellflag] = useState()
 const [intershowflag,         setIntershowflag] = useState()
 const [sellticketflag,       setSellticketflag] = useState()
 const [orderticketflag,     setOrderticketflag] = useState()
 
useEffect(() => {
  let arr_web_res =[]   // web reserveinfo
  let arr_web_buy =[]   // web buyinfo
  let arr_web_show=[]  // web show info
  let arr_buy=[]       // buy enabled
  let arr_res=[]       // res enabled
  for (let index = 0; index < grpEditArr.length; index++) {
         arr_web_res.push(grpEditArr[index].webReserveInfo  )
         arr_web_buy.push(grpEditArr[index].eventObject
          .WebbuyInfo.enabled  )
         arr_web_show.push(grpEditArr[index].webshowInfo)
         arr_buy.push(grpEditArr[index].buyEnabled)
         arr_res.push(grpEditArr[index].reserveEnabled )
    }
   
    setInternetorderflag(arr_web_res.every((no) => no === 1) === true ? 1 : arr_web_res.every((no) => no === 0) === true ? 0 : 2 )
    setInternetsellflag(arr_web_buy.every((no) => no === 1) === true ? 1 : arr_web_buy.every((no) => no === 0) === true ? 0 : 2 )

    setIntershowflag(arr_web_show.every((no) => no === 1) === true ? 1 : arr_web_show.every((no) => no === 0) === true ? 0 : 2 )

    setSellticketflag(arr_buy.every((no) => no === 1) === true ? 1 : arr_buy.every((no) => no === 0) === true ? 0 : 2 )

    setOrderticketflag(arr_res.every((no) => no === 1) === true ? 1 : arr_res.every((no) => no === 0) === true ? 0 : 2 )

}, [grpEditArr]);

// INTERNT BESTILLING
const [interorderChanged, setInterorderChanged] = useState();
const [interorderClicked2, setInterorderClicked2] = useState(false);
const [interOrder, setInterOrder] = useState(false);
const [interOrder2, setInterOrder2] = useState(2);

// INTERNET ORDER
useEffect(() => {
  setInterOrder(internetorderflag === 1 ? true : false)
 }, [internetorderflag]);


  const handleInternetOrder = () => {  
  
    setInterOrder((current) => !current)
    setInterorderChanged((current) => !current)
    setAclicked(true) 
  }
 
function  handleInternetOrder2(){
 
  setInterOrder2((interOrder2+1)%3)
  setA2clicked(true)
  // setInterorderChanged(true)

  // setInterorderClicked2(true)
 
}
useEffect(() => {
  if(interOrder2 == 0  || interOrder2 == 1){
    setInterorderChanged(true)
  }
  else setInterorderChanged(false)
}, [interOrder2]);




 useEffect(() => {
  // if(save_edit_clicked === true ) { 
 
}, [interOrder2, grpEditArr]);

// INTERNET SALG
const [intersalgChanged, setIntersalgChanged] = useState(false);
const [intersalgClicked2, setIntersalgClicked2] = useState(false);
const [interSalg, setInterSalg] = useState(false);
const [interSalg2, setInterSalg2] = useState(2);

useEffect(() => {
 setInterSalg(internetsellflag === 1 ? true : false)
}, [internetsellflag]);

const handleInternetSell = () => {
  setInterSalg((current) => !current)
  setIntersalgChanged((current) => !current)
  setBclicked(true)
 }
 function  handleInternetSell2(){
  setInterSalg2((interSalg2+1)%3)
  // setIntersalgClicked2(true)
  setB2clicked(true)
 }

useEffect(() => {
  if(interSalg2 == 0 || interSalg2 == 1) {
    setIntersalgChanged(true )
  }
  else {
    setIntersalgChanged(false)
  }
}, [interSalg2]);

 //INTERNET VISNING
const [intershowChanged, setIntershowChanged] = useState(false);
const [intershowClicked2, setIntershowClicked2] = useState(false);
const [interShow, setInterShow] = useState(false);
const [interShow2, setInterShow2] = useState(2);

useEffect(() => {
  setInterShow(intershowflag === 1 ? true : false)
}, [intershowflag]);


 const handleInternetShow = () => {
  setInterShow((current) => !current)
 setIntershowChanged((current) => !current)
 setCclicked(true)

 }
function handleInternetShow2(){
  setInterShow2((interShow2+1)%3)
  setC2clicked(true)
// setIntershowClicked2(true)
}

useEffect(() => {
  if(interShow2 === 0 || interShow2 === 1) {
    setIntershowChanged(true)
  }
  else 
    setIntershowChanged(false)  
}, [interShow2]);

// BUY ENABLED
const [buyChanged,  setBuyChanged] = useState(false);
const [buyClicked2, setBuyClicked2] = useState(false);
const [buyEnabled,  setBuyEnabled] = useState(false);
const [buyEnabled2, setBuyEnabled2] = useState(2);


useEffect(() => {
  setBuyEnabled(sellticketflag === 1 ? true : false)
}, [sellticketflag]);

const handleTicketSell = () => {
  setBuyEnabled((current) => !current)
  setBuyChanged((current) => !current)
  setDclicked(true)
//  if(save_edit_clicked === true ) { 

//   if(buyEnabled === false) {
//     grpEditArr.map((ev) => {
//       ev.eventObject.BuyEnabled = 1    
//     })
//   }
//   else {
//     grpEditArr.map((ev) => {
//       ev.eventObject.BuyEnabled = 0  
//     })
//   }
// }
 }
function handleTicketSell2(){
  setBuyEnabled2((buyEnabled2+1)%3)
  setD2clicked(true)
// setBuyClicked2(true)
}
useEffect(() => {
  if(buyEnabled2 === 0 || buyEnabled2 === 1) {
    setBuyChanged(true)
  }
  else   setBuyChanged(false)

}, [buyEnabled2]);

// RESERVE ENABLED
const [resChanged,  setResChanged] = useState(false);
const [resClicked2, setResClicked2] = useState(false);
const [resEnabled,  setResEnabled] = useState(false);
const [resEnabled2, setResEnabled2] = useState(2);

useEffect(() => {
  setResEnabled(orderticketflag === 1 ? true : false)
}, [orderticketflag]);

const handleTicketSellOrder = () => {
  // if(resEnabled === false) {
  //   grpEditArr.map((ev) => {
  //     ev.eventObject.ReserveEnabled = 1
  //   })
  // }
  // else {
  //   grpEditArr.map((ev) => {
  //     ev.eventObject.ReserveEnabled = 0
  //   })
  // }
  setResEnabled((current) => !current)
  setResChanged((current) => ! current)
  setEclicked(true)
 }
 function  handleTicketSellOrder2(){
  setResEnabled2((resEnabled2+1)%3)
  setE2clicked(true)
  // setResClicked2(true)
 }
 useEffect(() => {
  if(resEnabled2 === 0 || resEnabled2 === 1) {
    setResChanged(true)
  }
  else   setResChanged(false)

 }, [resEnabled2]);

  // ----------STEP MINUTES --------------
  const step_minutes = 5

  // ----search functionality------
  const [searchParam] = useState(["name"]);
  const [filterParam, setFilterParam] = useState(["name"]);
 
   function toFindDuplicates(arr) {
    const uniqueElements = new Set(arr);
    // const filteredElements =
    arr.filter((item) => {
      if (uniqueElements.has(item)) {
        // uniqueElements.delete(item);
      } else {
        return item;
      }
    });

    return [...new Set(uniqueElements)];
  }
  const data = Object.values(filmSearch?.length ? filmSearch : toFindDuplicates(allMovies) )
   
  function search(items) {
    return items.filter((item) => {
     
        if (filterParam == "name") {
            return searchParam.some((newItem) => {
                return (
                  item[newItem] && item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) > -1
                );
            });
        }
    });
   
  
  }
//  const [waitingModal, setWaitingModal] = useState(false);


  // EVENT SAVE API CALL 
  async function eventSave(ev) {
      ev.AllowOverlap = 1
      setWaitingModal(true)

        setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
          
            
          } 
         }, 2000)
   
  const res = await  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
            method: "POST",    
            headers: {
             'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
             'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(ev)}`
            
            })
  
    if(res.status === 200)  { 
      flag= true
    }  
   
     else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
    const json = await res.json()
   
    if(json) {
        setWaitingModal(false)
        setApiLoader(false)
        if(json.Result === 1) { 
         
            setEventSaveObj(json)  
         }
          else if(json.Result === -1) {
           
            eventPushCheck()
          }
         else if (json.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
         else  {
          setShowErrorModal(true)
          setErrorNo(json.Result)
          setErrorText(json.ErrorDescription)
        }
       }
     
    }
    
 


  function handleShowFilm () {
        setShowFilm( current => !current)
  }

     function findDuration(name) {
      let dura 
                  allMovies.filter((movie) => {
                    if(movie.name === name) { 
                      dura = movie.length
                      return dura
                    }
                  })
                  return dura
     }
     function draggedMovieNo (name) {
            let no
            allMovies.filter((movie) => {
              if(movie.name === name) { 
                no = movie.No
                return no
              }
            })
            return no
     }
   
      
  // ---- creating programmed films object ---
let moviesOnDate = Object.assign([],  allMovies)
let moviesPerDay = moviesOnDate.length > allMovies.length ? moviesOnDate : allMovies
if( newDraggedFilm) moviesPerDay.push(newDraggedFilm)

function findLocationId (i) {
    let id 
    allMovies.map((m) => {
      numberOfSal.map((s) => {

        if(s.No === i.locationId && m.No === i.movieId) {
        
           id = s.No
        }
       })
    })
    return id
}

  function findLocations (i) {
    
    let sal
         moviesPerDay.map((m) => {
          numberOfSal.map((s) => {

            if(s.No === i.locationId && m.No === i.movieId) {
            
               sal = s.name
            }
           })
        })
        return sal
  }
  

 

  function findMovieName (i) {
    let name 
    moviesPerDay.map((movie) => {
          
            if(i.movieId === movie.No) {
              name= movie.name
            }         
     })
     return name
  }
  
  function hasMovieLength (i) {
   
    let hasLength = false
    moviesPerDay.map((movie) => {
        if (movie.No === i.movieId) {
         
          movie.length > 0 ? hasLength = true: hasLength = false
        }
      })
      return hasLength
  }

  function findFDuration (i) {
      let length 
      allMovies.map((movie) => {
        if (movie.No === i.movieId) {
          length = movie.length
        }
      })
      return length > 0 ? length : 120   // if film does not have any length then it should be by default 120 (in minutes) 2 hours by default
  }



// ------------FILTERING EVENTS PER DATE --------------
 
  let same = eventSaveObj && eventsEdit.find(ev => 
       { return  ev?.No === eventSaveObj?.No && ev.RefNo === eventSaveObj.RefNo
       
       })

// if refno from eventSaveObj is not same as an event refno in eventsedit only then add it to 
   eventSaveObj &&  !same && eventsEdit.push(eventSaveObj)

  useEffect(() => {
    
     if(eventSaveObj) {
         const modifiedEv =   eventsEdit.filter(e => moment(e.start).format('DD-MM-YYYY') === moment(selectedDate).format('DD-MM-YYYY')).map((obj) => obj.RefNo === eventSaveObj?.RefNo ? eventSaveObj : obj)
     
         setEventsEdit(modifiedEv)
          }
     }, [eventSaveObj]);

 
  
   // copied_events is used for creating a copy of object and for changing the variables in it to be given to event_save later in the code
   let copied_events = JSON.parse(JSON.stringify(allEvents))
  
 

   let updatedEvents =  copied_events.map(ev => 
     eventsEdit.find(e => e?.No === ev.No) ? eventsEdit.find(e => e?.No === ev.No) :   ev
) 

  //  // updated events are the events which already existed before later changed or not changed
   let newlyCreatedEvs = eventsEdit &&  eventsEdit.filter(e => e?.No === 0)          // newly created events which has no event no
    
   
 
   let mergedEvents = newlyCreatedEvs && [...updatedEvents,  ...newlyCreatedEvs]

   let eventsPerDay = mergedEvents && mergedEvents.filter(e => moment(e.start).format('DD-MM-YYYY') === moment(selectedDate).format('DD-MM-YYYY')) 
 
 
 
     eventsPerDay = eventsPerDay.filter(obj => { return obj.movieId !== 0} )  // events med movieID 0 er sortet fra og derfor ikke med i eventsperday
    let events_today = eventsEdit.filter(e => moment(e.start).format('DD-MM-YYYY') === moment(selectedDate).format('DD-MM-YYYY')) 

   


    function calculateX (e, fors_start, fors_end) {
      let table_width = document.getElementById('program_table')?.clientWidth
      
      fors_start = Date.parse(moment(fors_start).format('yyyy-MM-DD HH:00'))    
      
      if (moment(fors_end).format('mm') > '00') fors_end = moment(fors_end).add(1,'hours')

      fors_end = Date.parse(moment(fors_end).format("yyyy-MM-DD HH:00"))

      let total_minutes = (fors_end - fors_start)/60000
      let pixelsprminute = table_width / total_minutes
       
      let start_minute_count = (moment(e.start) - fors_start)/60000
      let startx = Math.round(start_minute_count * pixelsprminute)
   
     
      return startx
    }

    function calculateY (e) {
      let salIndex
     
      for(let x=0;x<numberOfSal.length;x++)
      {
       
         if (numberOfSal[x].No === e.locationId)
         {
           salIndex=x
           break;
         }
      } 
     
      let rowheight = (document.getElementById('t_body')?.clientHeight/numberOfSal.length)
      let y =  52 + (salIndex * rowheight)
    
   return Math.round(y+3)
   
    }
 
function findLocIndex (i) {
  let salIndex
  for(let x=0;x<numberOfSal.length;x++)
  {
     if (numberOfSal[x].No === i.locationId)
     {
       salIndex=x
       break;
     }
  }
    return salIndex
}

function findTickettypesName (e) {

  let name 
  allTicketTypes.map((type) => {
    if(e.ArrTypeNo === type.No) {
      name = type.Name
    }
  })
  return name

}

  let ProgrammedEvents = []
  let times = []
  let dateTimesArr = []
  let showEndTime = []
  
  const [dragProgrammed,   setDragProgrammed] = useState(false)
  const [theDraggedElm,    setTheDraggedElm]  = useState([])
  const [theNewdraggedElm, setTheNewdraggedElm] = useState([]);


  for(let i = 0; i < eventsPerDay.length; i++) {
    if(eventsPerDay[i].movieId > 0) {
      ProgrammedEvents.push({
      eventObject:eventsPerDay[i],
      movieSelected:moviesSelected,
      eventEdit: eventsChanged,
      isOpen:showDropdown,
      index : findLocIndex(eventsPerDay[i]),
      event_No :eventsPerDay[i].No,
      name:   findMovieName(eventsPerDay[i]),
      movieLength:hasMovieLength(eventsPerDay[i]),
      length: findFDuration(eventsPerDay[i]),
      y_axis: calculateY(eventsPerDay[i]),
      x_axis: 0,
      ref_No : eventsPerDay[i].RefNo,
      locationId: findLocationId(eventsPerDay[i]),
      start: moment(eventsPerDay[i].start).format('HH:mm'),     
      end: moment(moment(eventsPerDay[i].start).add(findFDuration(eventsPerDay[i]), 'm').toDate()).format('HH:mm'),
      sal: findLocations(eventsPerDay[i]),
      ArrTypeName: eventsPerDay[i].ArrTypeName,
      webReserveInfo: eventsPerDay[i].WebreserveInfo?.enabled,
      webbuyInfo: eventsPerDay[i].WebbuyInfo?.enabled,
      webshowInfo: eventsPerDay[i].WebshowInfo?.enabled,
      buyEnabled: eventsPerDay[i].BuyEnabled,
      reserveEnabled: eventsPerDay[i].ReserveEnabled,
      numberedSeats:eventsPerDay[i].hasNumberedSeats,
      priceGroups:eventsPerDay[i].PriceGroups,
      tickettypes: findTickettypesName(eventsPerDay[i]),
      ArrTypeNo:eventsPerDay[i].ArrTypeNo,
      UsePriceGroupTemplate:eventsPerDay[i].UsePriceGroupTemplate,
      UseTicketTypeTemplate:eventsPerDay[i].UseTicketTypeTemplate
    })

    times.push(moment(eventsPerDay[i].start).format('HH:mm'))
    dateTimesArr.push(moment(eventsPerDay[i].start).format('YYYY-MM-DD HH:mm'))
    showEndTime.push(moment(moment(eventsPerDay[i].start).add(findFDuration(eventsPerDay[i]), 'm').toDate()).format('YYYY-MM-DD HH:mm'))
   
  }
  }

  dateTimesArr = dateTimesArr.sort()
  showEndTime  =  showEndTime.sort()

 for(let i = 0; i <eventsPerDay.length; i++) {
   
      if(eventsPerDay[i].movieId > 0 ) {
    ProgrammedEvents[i].x_axis = calculateX(eventsPerDay[i], dateTimesArr[0], showEndTime[showEndTime.length-1])
    }
    // ProgrammedEvents[i].index = theDraggedElm.index

  }

useEffect(() => {
   selectAllFilmAtOnce === true ? setMoviesSelected(true) : setMoviesSelected(false)
},[selectAllFilmAtOnce,setMoviesSelected])

  const [last, setLast] = useState();

  let g = showEndTime[showEndTime.length - 1]
 
  useEffect(() => {
    if(moment(g).format('mm') > '00') {
     
      let d = moment(g).add(1, 'hour')
    
      setLast(moment(d))
     }
     else 
     setLast(g)
  },[g])
 



    //---------time calculations below ------------
  let timeStamp = []
//--------DEFAULT START TIME AND DEFAULT END TIME if no events are programmed
  let default_start = `${moment(selectedDate).format('YYYY-MM-DD')}T11:00`
  let default_end   = `${moment(selectedDate).format('YYYY-MM-DD')}T20:00`

  const [timeEnd, setTimeEnd] = useState('');
  let fors_start =  dateTimesArr[0]

  let fors_end   =showEndTime[showEndTime.length - 1]
  
  const dt_start = 
   eventsPerDay && eventsPerDay.length === 0 ? Date.parse(default_start) : Date.parse(fors_start)
  const dt_end = 
  //  timeEnd ? Date.parse(moment(timeEnd).format( "YYYY-MM-DD HH:mm")) : 
  eventsPerDay && eventsPerDay.length === 0 ? Date.parse (default_end) : 
   Date.parse(last)
  

  let te =   timeEnd ? moment(timeEnd).format('HH') :eventsPerDay && eventsPerDay.length === 0 ? moment(dt_end).format('HH') :  moment(last).format('HH')
 
       

let t_start = moment(dt_start).format('HH')
let t_end = moment(dt_end).format('HH') == '00'  ? '24' 
:  moment(dt_end).format('HH') == '01' ? '25'
:  moment(dt_end).format('HH') == '02' ? '26'
:  moment(dt_end).format('HH') == '03' ? '27'
:  moment(dt_end).format('HH')
 
    for (let index = t_start; index < t_end;  index ++) {

           timeStamp.push(index)
  
    }
    
   let pixelWidthPerMin = 1698/(timeStamp.length*60).toFixed(2)

   const [comitCount, setComitCount] = useState();
   const [callPush, setCallPush] = useState(false);
   const [changesMax, setChangesMax] = useState(0);
  //  const [changes, setChanges] = useState();
   
  // GEM KUN VALGTE I BILLETSYSTEM
 async function saveChosenInSystem () {
   let count = 0


     let eventsToday = eventsEdit.filter(e => moment(e.start).format('DD-MM-YYYY') === moment(selectedDate).format('DD-MM-YYYY'))
      
     let eventsChosen =  updateProgram.filter(pro => { return pro.movieSelected === true })


    let eventsToAdd =    eventsChosen.map((pro) => {
        return  eventsToday.filter(ev => { return ev.RefNo ===  pro.eventObject.RefNo})[0]
       })
      for (let index = 0; index < eventsToAdd.length; index++) {
     
        let ev = eventsToAdd[index]
    
     
         let theEv = Object.assign({},ev)
        
      setCommitModal(true)
      let flag = false 
      async function eventCommit () {
          setWaitingModal(true)
       
         
         setTimeout(function () {
           if(flag === false) {         
               setApiLoader(true)
            
            
          } 
         }, 2000)
     const res =  await  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_commit` ,{
             method: "POST",    
             headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                 'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(theEv)}`
            
            })
 if(res.status === 200)  { 
      flag= true
    }  
    else {    
           setCommitModal(false)
           setWaitingModal(false)
           setShowErrorModal(true)
           setErrorStatus(res.status)
           setErrorType(res.type)       
        }
    const json = await res.json()
 if(json) {
       if (json.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
       else { 
          setWaitingModal(false)
          setApiLoader(false)
         
  }
 }
        }
        
         await eventCommit()
          count = count + 1

  setComitCount(count)
  if(count === eventsToAdd.length) {
   setCallPush(true)  // setting callPush to true will call eventpush
  
  }
  
    

  }  // loop ends here
  
}

const [event_push_error, setEvent_push_error] = useState(false);

let interval

useEffect(() => {

  // calling man event push check every 5 seconds untill changesLeft is 0
  if(changesLeft > 0 && changesLeft !== 0 && event_push_error === false) {
   interval =  setInterval(eventPushCheck, 5000)
  }
  

  return () => clearInterval(interval)
}, [changes, changesLeft]);

useEffect(() => {
 
  // if callpush is true call man event push
  if(callPush === true) {
     eventPush()

  }

}, [callPush]);



// ------------GEM  ALLE DAGES RETTELSER I BILLETSYSTEM-------------everything from event save/ghost
 async function saveAllInSystem () {

   
  let count = 0
  for (let index = 0; index < eventsEdit.length; index++) {
    const ev = eventsEdit[index];
    
  
        let theEv = Object.assign({},ev)
        setCommitModal(true)
 
       let flag = false 
        ev.AllowOverlap = 1 

        async function eventCommit () {
          setWaitingModal(true)
       
         
         setTimeout(function () {
           if(flag === false) {         
               setApiLoader(true)
              
            
          } 
         }, 2000)
     const res =  await  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_commit` ,{
             method: "POST",    
             headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                 'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(theEv)}`
            
            })
         if(res.status === 200)  { 
             flag= true
            }  
          else {    
              setCommitModal(false)
              setWaitingModal(false)
              setShowErrorModal(true)
              setErrorStatus(res.status)
              setErrorType(res.type)       
           }
       const json = await res.json()
        if(json) {
          if (json.Result === 0) {
       // log out
           logOut()
           navigate('/') 
          }   else  {
               setWaitingModal(false)
               setApiLoader(false)  
          }
                             
          }
        }
    
        await eventCommit()
        count= count + 1
        setComitCount(count)
         if(count === eventsEdit.length) {
            setCallPush(true)  // setting callPush to true will call eventpush api
  
          }

 
   
  // count = count + 1
 
 }  // loop ends here
}


//--------- 4 button click functions -----------
function handleSelectAll () {

  setSelectAllFilmAtOnce((current) => !current)
  
}
function handleCopy () {
  (selectAllFilmAtOnce || anyMovieSelected) &&
  setCopyChosen((current) => !current)
}


function cancelCopy () {
setDeletebtnclk(true)

setCopyChosen(false)
setSelectAllFilmAtOnce(false)
setAnyMovieSelected(false)
}


//-----function below is used to calculate days between startdate and enddate chosen for copying
function enumerateDaysBetweenDates (date1, date2){
  let date = []
  while(moment(date1) <= moment(date2)){
    date.push(date1);
    date1 = moment(date1).add(1, 'days').format("YYYY-MM-DD");
  }
  return date;
}

const [ overlapDiv, setOverlapDiv] = useState(false)

useEffect(() => {
 let f = document.getElementById('overlap');
      //  f && overlapDiv === false ? f.style.display='none' : f.style.display=''
},[overlapDiv])

function handlecopyclosebtn () {
  setOverlapDiv(false)
 
let docs = document.getElementById('tes')

  let g = document.getElementsByClassName('overlap-modal')[0]

  docs.removeChild(g)


 setSelectAllFilmAtOnce(false)
 setCopied(true)  // makes getprogram run again
 window.location.reload()
}


function handleGroupEdit() {


}

const [copyObject, setCopyObject] = useState([]);

const clientHeight =allMovies.length && document.getElementById('tes').clientHeight
// const [daysRange, setDaysRange] = seState([])


  let theChosedDays = enumerateDaysBetweenDates(moment(startDate).format('YYYY-MM-DD'),moment(endDate).format('YYYY-MM-DD'))


  const [dateError, setDateError] = useState(false);

  useEffect(() => {
    if(moment(endDate).isBefore(startDate) || !endDate) setDateError(true)
      else setDateError(false)
  }, [endDate, startDate]);


const [apiCounter, setapiCounter] = useState();

 async function saveCopy () {
  setCopied(false)

 
  if(!dateError) { 
       setShowCopyModal(true)
//  let overlap_copy = document.getElementsByClassName('overlap-modal')

 let eventsChosen =  updateProgram.filter(pro => { return pro.movieSelected === true })



  // let lapDiv = document.getElementById('overlap')


let docs = document.getElementById('tes')
let modalBack = document.createElement('div')
modalBack.className='overlap-modal '

 modalBack.style.left=Math.round(leftMargin)+'px'
 modalBack.style.height= Math.round(clientHeight)+'px'
// modalBack.style.width='1858px'
let modalContent = document.createElement('div')
modalContent.className='overlap-content'
//modalContent.style.height='645px'
modalContent.style.width='853px'

modalContent.style.top = windowHeight > 1000 ? '-40px' : '-204px'

let overlapContainer = document.createElement('div')
overlapContainer.id='overlap'
let titleDiv = document.createElement('div')
titleDiv.className='title-div'
let text = document.createElement('p')
text.innerHTML='Kopiering er i gang'
text.className='bemark'
let close_btn = document.createElement('button')
close_btn.innerHTML='X'
close_btn.className='close-btn'
close_btn.addEventListener('click', handlecopyclosebtn)
let okBtn = document.createElement('button')
okBtn.innerHTML='OK'
okBtn.className='ok-btn'

okBtn.addEventListener('click', handlecopyclosebtn)
modalContent.appendChild(titleDiv)
titleDiv.appendChild(close_btn)
titleDiv.appendChild(text)
modalBack.appendChild(modalContent)
modalContent.appendChild(overlapContainer)
// 
 let counterdiv = document.createElement("div")
       modalContent.appendChild(counterdiv)
       counterdiv.className='api-counter'

 let h4 =   document.createElement('p')
 h4.className='overlap-title'
  h4.innerHTML = 'List herunder viser de fejl der er opstået ved kopiering'
  overlapContainer.appendChild(h4)
 setCopyObject(eventsChosen)
let count = 0
let count_max = document.createElement('p')
count_max.innerHTML = eventsChosen.length *  theChosedDays.length
count_max.className='count_max'
    let counter = document.createElement('p')
    counterdiv.appendChild(counter)
    counterdiv.appendChild(count_max)



 for (let i = 0; i <  theChosedDays.length; i++) {

        for (let index = 0; index < eventsChosen.length; index++) {
    let theEvent = eventsChosen[index]

      
        let save = true
    
        
        let ev = Object.assign({}, theEvent.eventObject)
        let the_ev =  Object.assign({}, theEvent)
        ev.No = 0 // ev with event no 0
        ev.RefNo = 0  // ev with RefNo 0
        ev.AllowOverlap = 1
        ev.start = theChosedDays[i]+'T'+moment(ev.start).format('HH:mm:ss')  // ev with new date
       
         
        let m_ev =   allMovies.filter(movie => { return movie.No === ev.movieId})
        let new_event_start = ev.start
        let new_event_end = moment(moment(ev.start).add(m_ev[0].length+ev.AdvertisementTrailer, 'm')).format('YYYY-MM-DD HH:mm')
        
        let overlap = false
         let flag = false
        
      
//         // Kig alle events igennem for at finde dem der rammer dato og sal
        mergedEvents.map( (event) => {

          if (moment(event.start).format('YYYY-MM-DD') === theChosedDays[i] && event.locationId === ev.locationId) {
            
           let m =     allMovies.filter(movie => { return movie.No === event.movieId})
          
            let original_event_start = event.start
            let original_event_end = moment(moment(event.start).add(m[0].length+event.AdvertisementTrailer, 'm')).format('YYYY-MM-DD HH:mm')

              setOverlapModal(true)
                if(moment(new_event_start).format('HHmm') < moment(original_event_end).format('HHmm') && moment(new_event_end).format('HHmm') > moment(original_event_start).format('HHmm'))
              {
                 overlap = true
                
                  save= false
               
              }
   
           }
          
      })
  let status = document.createElement('p')

        let div =  document.createElement("div");
        div.className ='overlap_list'
        let name = document.createElement('p')
        let sal = document.createElement('p')
        let date = document.createElement('p')
        let timestart = document.createElement('p')
        // let timeend = document.createElement('p')
        name.innerHTML = the_ev.name
        sal.innerHTML = the_ev.sal
        date.innerHTML = moment(ev.start).format('DD-MM-YYYY')
        timestart.innerHTML = moment(ev.start).format('HH:mm')
       
        div.appendChild(name)
        div.appendChild(sal)
        div.appendChild(date)
        div.appendChild(timestart)
        // div.appendChild(timeend)
        div.appendChild(status)
      
        docs.appendChild(modalBack) 
 
      if(overlap) {
       overlapContainer.appendChild(div)
       
        status.innerHTML = 'forestilling overlap'
       
       }
       else  { 
   
        
      
      async function eventSaveCopy () {
         ev.AllowOverlap = 1 
        setWaitingModal(true)
        
       setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
          
            
          } 
         }, 2000)
      
      
     const res =  await   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
             method: "POST",    
            headers: {
             'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
             'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(ev)}`
            
            })
           
 
     if(res.status === 200)  { 
         flag =  true
     }  
    else {    
           setShowErrorModal(true)
           setErrorStatus(res.status)
           setErrorType(res.type)       
        }
    const json = await res.json()
    flag =  true
      
  
    if(json) {
        setWaitingModal(false)
        setApiLoader(false)
        
        if(json.Result === 1) { 
            setEventSaveObj(json)  
            status.innerHTML = 'oprettet'
          }
            else if (json.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(json.Result === -1) {
          
            eventPushCheck()
          }
          else {
             let status = document.createElement('p')

        let div =  document.createElement("div");
        div.className ='overlap_list'
        let name = document.createElement('p')
        let sal = document.createElement('p')
        let date = document.createElement('p')
        let timestart = document.createElement('p')
        // let timeend = document.createElement('p')
        name.innerHTML = the_ev.name
        sal.innerHTML = the_ev.sal
        date.innerHTML = moment(ev.start).format('DD-MM-YYYY')
        timestart.innerHTML = moment(ev.start).format('HH:mm')
       
        div.appendChild(name)
        div.appendChild(sal)
        div.appendChild(date)
        div.appendChild(timestart)
        // div.appendChild(timeend)
        div.appendChild(status)
      
        docs.appendChild(modalBack) 
 
       overlapContainer.appendChild(div)
        status.innerHTML =`Error ${json.Result} : ${json.ErrorDescription},` 

          }

 }

        }
       
     await   eventSaveCopy()
      
      
      }
         
          count = count + 1
          counter.innerHTML = count
      }     
   

   }
 text.innerHTML='Kopiering er slut'
modalContent.appendChild(okBtn)
 setOverlapDiv(true)
 setCopyChosen(false)

 setSelectAllFilmAtOnce(false)


  }
  
}
  

// man_event_push call
function eventPush () {  
    setWaitingModal(true)

   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_push` ,{
        method: "POST",     
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',     
       },
       body:`Key=${key}&orgNo=${default_filmID ? default_filmID : orgSelect}`
   })
    .then(res =>  { 
        flag =  true
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => {
       setWaitingModal(false)
       setApiLoader(false)
      //  if(result.Result === 1) {
      setChangesMax(result.ChangesLeft)
       setChangesLeft(result.ChangesLeft)
        if(result.Result === 0 ) {
         // log out
           logOut()
           navigate('/') 
        }
        else { 
              if(result.Result > 1) {
                 setEvent_push_error(true)
                 setShowErrorModal(true)
                 setErrorNo(result.Result)
                 setErrorText(result.ErrorDescription)
              }
              if(result.ChangesLeft === 0) {
               // setCommitModal(false)
                  window.location.reload()
              }
            }
      })
      setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
        
            
          } 
         }, 2000)
     
}





function handleEdit () {

  (selectAllFilmAtOnce || anyMovieSelected) && setEditChosen((current => !current))
     let eventsChosen =  updateProgram.filter(pro => { return pro.movieSelected === true })
   
    setGrpEditArr(eventsChosen)

}

function deleteEvent () {
  let eventsChosen =  updateProgram.filter(pro => { return pro.movieSelected === true  })
  
   eventsChosen.map((ev) => {
    let theEv = ev.eventObject
    if(theEv.RefNo === 0) {  // if existing forestilling
        theEv.DeleteEvent = 1
       
        eventSave(theEv)
    } 
  else {
     eventCancel(theEv)  
     window.location.reload()

  }
    })

  }

 function deleteGhostEvent() {
    setEventDelete(true)
     let eventsChosen =  updateProgram.filter(pro => { return pro.movieSelected === true })

    eventsChosen.map((ev) => {
     let theEv = Object.assign({}, ev.eventObject)
 
     eventCancel (theEv)
    


   })    // event chosen map ending
   setalertEvents('')
   setAnyMovieSelected(false)
   setSelectAllFilmAtOnce(false)

  window.location.reload()

}

 function eventCancel (theEv) {
  setWaitingModal(true)

  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_cancel` ,{
      method: "POST",
     
     headers: {
      'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
      'Content-Type':  'application/x-www-form-urlencoded',    
     },
   
     body:`Key=${key}&eventdata=${JSON.stringify(theEv)}`
     
})
     .then(res =>  { 
           flag =  true
    
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 
          if(result.Result === 0) {
         // log out
           logOut()
           navigate('/') 
          }
          else  {
           setApiLoader(false)
           setWaitingModal(false)
          }
       
     
        })
        setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
         
            
          } 
         }, 2000)
}

const [save_edit_clicked, setSave_edit_clicked] = useState(false);
//-----on click function on button

function saveTheEdit () {
 

  if(aclicked === true ) {
    if(interOrder === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.WebreserveInfo ? 
        (ev.eventObject.WebreserveInfo.enabled = 0 ) 
        : (ev.eventObject.WebreserveInfo = {enabled: 0 })
      
        eventSave(ev.eventObject)
        
      })
    }
    else { 
      grpEditArr.map((ev) => {
        ev.eventObject.WebreserveInfo ? 
        (ev.eventObject.WebreserveInfo.enabled = 1 ) 
        : (ev.eventObject.WebreserveInfo = {enabled: 1 })
      
        eventSave(ev.eventObject)
  
      })
    }
  }
  if(a2clicked === true) {
    if(interOrder2 === 0 ) {
      grpEditArr.map((ev) => {

       if( ev.eventObject.WebreserveInfo) {
           if(ev.eventObject.WebreserveInfo.enabled === 0 ) {
            ev.eventObject.WebreserveInfo.enabled = 1 
            eventSave(ev.eventObject)
           }
       } 
        
        else { 
          ev.eventObject.WebreserveInfo = {enabled: 1 }
          eventSave(ev.eventObject)

        } 
       

      })
     // }
      // setInterorderChanged(true)
     }
     else if(interOrder2 === 1) {
      grpEditArr.map((ev) => {
        if(ev.eventObject.WebreserveInfo) {
           if(ev.eventObject.WebreserveInfo.enabled === 1) {
            ev.eventObject.WebreserveInfo.enabled = 0
            eventSave(ev.eventObject)

           }
        } 
       
        else {
          ev.eventObject.WebreserveInfo = {enabled: 0 }
          eventSave(ev.eventObject)

        } 
       
      })
      // setInterorderChanged(true)
     }
     else {
     grpEditArr.map((ev) => {
        ev.eventObject.WebreserveInfo ? 
        (ev.eventObject.WebreserveInfo.enabled = ev.webReserveInfo ) 
        : (ev.eventObject.WebreserveInfo = {enabled:  ev.webReserveInfo })
       
       
      })
      // setInterorderChanged(false)
     }
  }

  if(bclicked === true ) {
    if(interSalg === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.WebbuyInfo? 
        (ev.eventObject.WebbuyInfo.enabled = 0 ) 
        : (ev.eventObject.WebbuyInfo = {enabled: 0 })
        eventSave(ev.eventObject)

       
      })
    }
    else {
      grpEditArr.map((ev) => {
        ev.eventObject.WebbuyInfo? 
        (ev.eventObject.WebbuyInfo.enabled = 1 ) 
        : (ev.eventObject.WebbuyInfo = {enabled: 1 })
        eventSave(ev.eventObject)

       
      })
    }
  }

 if(b2clicked === true ) {
  if(interSalg2 === 0) {
    grpEditArr.map((ev) => {
      if(ev.eventObject.WebbuyInfo) {
         if(ev.eventObject.WebbuyInfo.enabled === 0 ) {
            ev.eventObject.WebbuyInfo.enabled = 1
            eventSave(ev.eventObject)
      }
    } 
    
      else { 
        ev.eventObject.WebbuyInfo = {enabled: 1 }
        eventSave(ev.eventObject)

      }
     
    })
    
  }
  else if( interSalg2 === 1) {
    grpEditArr.map((ev) => {
      if(ev.eventObject.WebbuyInfo){
          if(ev.eventObject.WebbuyInfo.enabled === 1) {
            ev.eventObject.WebbuyInfo.enabled = 0
            eventSave(ev.eventObject)

          }
      }
     
      else {
        ev.eventObject.WebbuyInfo = {enabled: 0 }
        eventSave(ev.eventObject)

      } 
      
    })
   
  }
  else {
    grpEditArr.map((ev) => {
      ev.eventObject.WebbuyInfo? 
      (ev.eventObject.WebbuyInfo.enabled = ev.webbuyInfo ) 
      : (ev.eventObject.WebbuyInfo = {enabled: ev.webbuyInfo  })
    })
    
  }
 }

  if(cclicked === true) {
    if(interShow === false) {
        grpEditArr.map((ev) => {
          ev.eventObject.WebshowInfo ? 
          (ev.eventObject.WebshowInfo.enabled = 0 ) 
          : (ev.eventObject.WebshowInfo = {enabled: 0 })
        eventSave(ev.eventObject)

         
        })
      }
      else {
        grpEditArr.map((ev) => {
          ev.eventObject.WebshowInfo ? 
          (ev.eventObject.WebshowInfo.enabled = 1 ) 
          : (ev.eventObject.WebshowInfo = {enabled: 1 })
        eventSave(ev.eventObject)

         
        })
      }
  }
 if(c2clicked === true) {
     if(interShow2 === 0) {
      grpEditArr.map((ev) => {
        if(ev.eventObject.WebshowInfo) {
           if(ev.eventObject.WebshowInfo.enabled === 0 ) {
              ev.eventObject.WebshowInfo.enabled = 1
              eventSave(ev.eventObject)
        }
      } 
      
        else { 
          ev.eventObject.WebshowInfo = {enabled: 1 }
          eventSave(ev.eventObject)
  
        }
       
      })
     }
     else if(interShow2 === 1) {
       grpEditArr.map((ev) => {
        if(ev.eventObject.WebshowInfo){
            if(ev.eventObject.WebshowInfo.enabled === 1) {
              ev.eventObject.WebshowInfo.enabled = 0
              eventSave(ev.eventObject)
  
            }
        }
       
        else {
          ev.eventObject.WebshowInfo = {enabled: 0 }
          eventSave(ev.eventObject)
  
        } 
        
      })
     }
     else {
      grpEditArr.map((ev) => {
        ev.eventObject.WebshowInfo? 
        (ev.eventObject.WebshowInfo.enabled = ev.webshowInfo ) 
        : (ev.eventObject.WebbuyInfo = {enabled: ev.webshowInfo  })
      })
      
    }
 }
  if(dclicked === true) {
    if(buyEnabled === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.BuyEnabled = 0  
        eventSave(ev.eventObject)
       
        
      })
    }
    else {
      grpEditArr.map((ev) => {
        ev.eventObject.BuyEnabled = 1
        eventSave(ev.eventObject)

      })
    }
  }
  if(d2clicked === true) {
   if(buyEnabled2 === 0) {
       grpEditArr.map((ev) => {
        if(ev.eventObject.BuyEnabled === 0) {
          ev.eventObject.BuyEnabled=1
          eventSave(ev.eventObject)
        }
        // else {
        //   ev.eventObject.BuyEnabled = 0
        //   eventSave(ev.eventObject)

        // }
       })
   }
   else if(buyEnabled2 === 1) {
      grpEditArr.map((ev) => {
        if(ev.eventObject.BuyEnabled === 1) {
          ev.eventObject.BuyEnabled = 0
        }
        // else {
        //   ev.eventObject.BuyEnabled
        // }
      })
   }
   else {
    grpEditArr.map((ev) => {
      ev.eventObject.BuyEnabled = ev.buyEnabled
      
    })
   }
}
  if(eclicked === true) {
    if(resEnabled === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.ReserveEnabled = 0
        eventSave(ev.eventObject)

      })
    }
    else {
      grpEditArr.map((ev) => {
        ev.eventObject.ReserveEnabled = 1
        eventSave(ev.eventObject)

      })
    }
  }
  if(e2clicked === true) {
    if(resEnabled2 === 0) {
      grpEditArr.map((ev) => {
       if(ev.eventObject.ReserveEnabled === 0) {
         ev.eventObject.ReserveEnabled=1
         eventSave(ev.eventObject)
       }
       // else {
       //   ev.eventObject.BuyEnabled = 0
       //   eventSave(ev.eventObject)

       // }
      })
  }
  else if(resEnabled2 === 1) {
     grpEditArr.map((ev) => {
       if(ev.eventObject.ReserveEnabled === 1) {
         ev.eventObject.ReserveEnabled = 0
       }
       // else {
       //   ev.eventObject.BuyEnabled
       // }
     })
  }
  else {
   grpEditArr.map((ev) => {
     ev.eventObject.ReserveEnabled = ev.buyEnabled
     
   })
  }
  }

 
  let eventsprog =  updateProgram.filter(pro => {return pro.movieSelected === true})
 
  //  setEditedEvents(eventsprog)
   setSelectAllFilmAtOnce(false)
   setEditChosen(false) 
  
   setAnyMovieSelected(false)
  //  setSaveFilmEdit(false)
   setSavebtnclk(true)
  
}



function deleteTheEdit () {
  setAnyMovieSelected(false)
  setDeletebtnclk(true)
 
  setEditChosen((current => !current))
  setSaveFilmEdit(false)

  // setInternetorderflag(2)
  // setInternetsellflag(2)
  // setIntershowflag(2)
  // setSellticketflag(2)
  // setOrderticketflag(2)

  setSelectAllFilmAtOnce(false)
   let eventsprog =  updateProgram.filter(pro => {return pro.movieSelected === true})
   eventsprog.map(ev => {
     ev.movieSelected= false
   })
 
   window.location.reload()
}

function editChosenFilm () {
  setEditChosen((current => !current))
}

function handleCalendar () {
  setOpenCalendar((current => !current))
}
function handleStartDatoCal () {
  if(endDatoCal   === true) setEndDatoCal(false)
  setStartDatoCal((current => !current))
}
function handleEndDatoCal () {
  if(startDatoCal === true) setStartDatoCal(false)
  setEndDatoCal((current => !current))
}
function closeCalendar() {
  setStartDatoCal(false)
}

// useEffect(() => {
//  internetOrder === true ? setShowAlert(true) : setShowAlert(false)
// })

// transparent image on drag
    const img = new Image()
    img.src = trans

 
 //------------ runs when dragging the film image starts----------   
 function handleOnDrag (e,widgetType,movie ) {
 // addToMovies(movie)
//  e.preventDefault()

  //  e.dataTransfer.dropEffect = "move";
  e.dataTransfer.effectAllowed = "copyMove";
  setNewDraggedFilm(movie)
  setDraggedMovieId(movie.No)

    e.dataTransfer.setDragImage(img, 0,0)
    e.nativeEvent.hidden = true
    e.dataTransfer.setData('widgetType', widgetType)
    setDraggedFilm(movie.name)
    
    setFilmWidth(e.target.attributes.duration.value == 0 ? '90' : e.target.attributes.duration.value) 
   // setShowFilm((current=> !current))
 }
 //----------runs when dragging the film image ends ---------
 function imgDragEnd(e) { 
  e.dataTransfer.dropEffect === 'none' ? setShowG(false) : setShowG()
  setShowTime(false) 
}
//--------- removing ghost image while dragging the film ----------
 function draggingDiv(e) {
   const img = new Image()
         img.src = ''
        e.dataTransfer.setDragImage(img, 0,0)
 }


//------------runs when dragged div is dragged over the table area ---------------
function handleDragOver(e) {

   setShowFilm(false)
   setDragStarted(true)
    e.preventDefault()  
   
  
   e.dataTransfer.types.length  && draggedFilm  ? setShowG(true) : setShowG(false) 
   
    let tbodyHeight = document.getElementById('t_body').clientHeight
    let theadHeight = document.getElementById('t_head').clientHeight

  
   let sal_y = calculateYax(e)

   setY(sal_y)
  
  
//-----------formula for obtaining x axis--------

 const [snap_to_x, snap_to_x_before ]  = calculateXaxis(e)

 let start_time =moment(Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00')).add(Math.round(snap_to_x_before)*step_minutes, 'm').toDate()

 setStartTime(moment(start_time).format('YYYY-MM-DD  HH:mm'))
 // let end_time = moment(start_time).add(filmWidth, 'm').toDate();
 setX(snap_to_x ) 



  }



//-------- runs when film div is dropped on table-----------------
  function handleOnDrop (e) {
  setDragEnded(true)

setdragging(false)
   setShowTime(false)
  //let tbodyHeight = document.getElementById('t_body').clientHeight
  let theadHeight = document.getElementById('t_head').clientHeight
  
  const widgetType = e.dataTransfer.getData('widgetType') 
   widgetType && setWidgets([...widgets, widgetType]) 
  
  
  //-----------formula for obtaining Y-AXIS--------------
   let sal_y = calculateYax(e)
   let sal_index = (sal_y - (theadHeight+3))/48

//  if (sal_y < 0) sal_y = 0
//  sal_y = sal_y + 3

   let [snap_to_x, snap_to_x_before ]  = calculateXaxis(e)

 //snap_to_x_before = snap_to_x

  //------------saving the start time of particular film---------
 
  let start_time = moment(Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00')).add(Math.round(snap_to_x_before)*step_minutes, 'm').toDate();



//  setShowStartTimeArr([...showStartTimeArr, moment(start_time).format('YYYY-MM-DD HH:mm')])
 
 let end_time = moment(start_time).add(filmWidth, 'm').toDate();

    
  let newTimeStart = moment(selectedDate).format('YYYY-MM-DD')+'T'+theDraggedElm?.start+':00'



let theEvent
draggedMovieId > 0 ? theEvent = {   //  new dragged event
  movieId: draggedMovieId,
  No: 0,
  RefNo:0,
  start:  moment(start_time).format('YYYY-MM-DD HH:mm'),
  end: moment(end_time).format('YYYY-MM-DD HH:mm'),
  locationId:  numberOfSal[sal_index].No,
  OrgNo: orgSelect,
  // allowOverlap: allowOverlap === 'true' ? 1  : 0,
} 
: theEvent = eventsPerDay.find(e => {   // existing event
  if( e.No ===  theDraggedElm.event_No && theDraggedElm.ref_No === e.RefNo) {
       e.start = newTimeStart
      
       
     return  e
  }
})


  
     let ev = theEvent

      //  draggedMovieId > 0 ? ev.start = moment(start_time).format('YYYY-MM-DD HH:mm') : ev.start = newTimeStart      // rewriting the start time
     ev.locationId = numberOfSal[sal_index].No
   
     let draggedEv = updateProgram.find((event) => { return event.event_No === ev.No && event.event_No !== 0})
     let newDraggedEv =  Object.assign({},ev)
     
      newDraggedEv.start = moment(newDraggedEv.start).format('HH:mm')
      newDraggedEv.end = moment(newDraggedEv.end).format('HH:mm')
    

    //  let overlap = false
   
     setTheNewdraggedElm( !draggedEv && newDraggedEv)

     
  
 
   
//-----EVENT SAVE api call----//
// eventSave(ev)
  ev.AllowOverlap = 1 
    setWaitingModal(true)
  
  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
        method: "POST",
       
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',
        
       },
     
       body:`Key=${key}&eventdata=${JSON.stringify(ev)}`
       
   })
   .then(res =>  { 
        flag =  true
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
   .then(result => { 
     setWaitingModal(false)
     setApiLoader(false)
     if(result.Result === 1) { 
    
         setEventSaveObj(result) 
         setDraggedMovieId('')
         setDraggedFilm('')
     }
       else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(result.Result === -1) {
       
            eventPushCheck()
          }
     else {
        setShowErrorModal(true)
        setErrorNo(result.Result)
        setErrorText(result.ErrorDescription)
      }

 })
     setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
          
            
          } 
         }, 2000)
  
  }


 function overlapOkBtn () {
    setDivOverlap(false)
    setTheDraggedElm([])
   
 }

  useEffect(() => {
    setDivOverlap(false)
  }, [selectedDate]);

  
 
 function calculateXaxis (e) {


  let mouse_x =  Math.floor( e.clientX - document.getElementById('program_table').getBoundingClientRect().x )
  let timestamp_start = moment(Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00'))._i
  let timestamp_end   = moment(Date.parse(moment(dt_end).format('YYYY-MM-DD HH')+':00'))._i
  
  let table_width   = document.getElementById('program_table').clientWidth
  let total_minutes = (timestamp_end - timestamp_start)/60000
  
  let time_steps    = total_minutes / step_minutes
  let pixelPrStep   = table_width / time_steps;
  let rest_x        = mouse_x % pixelPrStep
  let snap_to_x_before = ((mouse_x - rest_x - mouseOffset) / pixelPrStep)
  let snap_to_x     = Math.round(snap_to_x_before * pixelPrStep)
  
    return [snap_to_x , snap_to_x_before, ]

 }


 function calculateYax (e) {

  let tbodyHeight = document.getElementById('t_body').clientHeight
  let theadHeight = document.getElementById('t_head').clientHeight
  let salHeight = tbodyHeight / numberOfSal.length
  let cY = e.clientY - (document.getElementById('program_table').getBoundingClientRect().y+theadHeight+3)
  cY < 0 ? cY = 0 : (cY > tbodyHeight? cY = tbodyHeight : cY = cY)
  
  let snap_y = 0
  for (let index = 0; index < tbodyHeight; index= index + salHeight) {
    if(e.clientY < (document.getElementById('program_table').getBoundingClientRect().y+theadHeight+3+(index+salHeight))) {
      if(snap_y == 0) {
        snap_y = index + 3 + theadHeight
        
      }
    }
    
  }
  if (snap_y == 0) 
  {
      snap_y = (theadHeight+3 +tbodyHeight) - salHeight
      
  }
 
  return snap_y
}




//-------------colors which indicates the sal/halls 
let sal1Color  = '#dbe754';
let sal1Color2 = '#f5fabf';
let sal1Color3 = 'rgba(219,231,84, 0.3)';
let aktivColor1= '#ADB920';
let sal1popbg2 = '#FBFFCF';
let sal1popbg3 = '#FCFFDE';

let sal2Color  = '#adb0ff'; 
let sal2Color2 = '#e5e6fb';
let sal2Color3 = 'rgba(173,176,255, 0.25)';
let aktivColor2= '#9498F6';
let sal2popbg2 ='#EBECFC';
let sal2popbg3 ='#F6F6FF'

let sal3Color  = '#ff9b2f';
let sal3Color2 = '#feebd7';
let sal3Color3 = 'rgba(225,166,47, 0.2)';
let aktivColor3= '#FF9B2F';
let sal3popbg2 = '#FEF1E2'
let sal3popbg3 = '#FEF5EC'

let sal4Color  = '#a9e5ff';
let sal4Color2 = '#def5ff';
let sal4Color3 = 'rgba(169,229,255, 0.3)';
let aktivColor4= '#37B7EE';
let sal4popbg2 = '#EBF9FF'
let sal4popbg3 = '#F5FCFF'

let sal5Color  = '#7ee56d';
let sal5Color2 = '#c9fbc0';
let sal5Color3 = 'rgba(126,228,109, 0.25)';
let aktivColor5= '#3EBB29';
let sal5popbg2 = '#D8F7D2'
let sal5popbg3 = '#E5FAE1'

let sal6Color  = '#f15f56'
let sal6Color2 = '#FADEDD'
let sal6Color3 = 'rgba(241, 95, 86, 0.15)'
let aktivColor6= '#F7574D';
let sal6popbg2 = '#FFEBEB'
let sal6popbg3  ='#FFF3F2'

let sal7Color  = '#3bc4a0'
let sal7Color2 = '#dbf7f0'
let sal7Color3 = 'rgba(59, 196, 160, 0.3)'
let aktivColor7= '#23A985';
let sal7popbg2 = '#E6FAF5'
let sal7popbg3 = '#F5FFFC'

let sal8Color  = '#f5c645'
let sal8Color2 = '#f7edd2'
let sal8Color3 = 'rgba(245, 198, 69, 0.25)'
let aktivColor8= '#DFA60A';
let sal8popbg2 = '#F5EFDC'
let sal8popbg3 = '#F9F5E9'

let sal9Color  = '#6978ff'
let sal9Color2 = '#e4e7ff'
let sal9Color3 = 'rgba(105, 120, 255, 0.2)'
let aktivColor9= '#6978FF';
let sal9popbg2 = '#F0F0FF'
let sal9popbg3 = '#F6F6FF'

let sal10Color = '#2c6b0f'
let sal10Color2= '#caf1b8'
let sal10Color3= 'rgba(44, 107, 15, 0.1)'
let aktivColor10='#2C6B0F';
let sal10popbg2 ='#D8FAC8'
let sal10popbg3 ='#E5FFD9'

let mouse_x_offset = 0
const [mouseOffset, setMouseOffset] = useState(0);
useEffect(() => {
  showFilm === true  && setQ('') 
}, [showFilm]);
  
function divClicked (e, event) {
   mouse_x_offset = e.clientX - event.x_axis - document.getElementById('program_table').getBoundingClientRect().x 
  setMouseOffset(mouse_x_offset)
  

}

//-------- following function runs when the existing film-show div is moved ----------
function dragExisting (e,event) {
 setdragging(true)
  setTheDraggedElm(event)
  setDragProgrammed(true)
  
  let theadHeight = document.getElementById('t_head').clientHeight

  let sal_y = calculateYax(e)

  let [snap_to_x, snap_to_x_before ]  = calculateXaxis(e, event)
  
  
   let start_time = moment( Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00'))
   .add(Math.round(snap_to_x_before )*step_minutes, 'm').toDate();

   let end_time = moment(start_time).add(event.length, 'm').toDate();



    event.start = moment(start_time).format('HH:mm')  // overriding start time of existing with dragged
    
    event.end   = moment(end_time).format('HH:mm')
    e.target.style.left = snap_to_x < 0 ? 0+'px' :snap_to_x  +'px'  // moves the dragged div in x-axis
 
  

  e.target.style.top = sal_y +'px' // moving the dragged div in y-axis
  let sal_index = (sal_y-(theadHeight+3))/48

 let bgColor= sal_index === 0 || sal_index === 10 || sal_index === 20 ? sal1Color 
 : sal_index === 1 || sal_index === 11 || sal_index === 21 ? sal2Color 
 : sal_index === 2 || sal_index === 12 || sal_index === 22 ? sal3Color 
 : sal_index === 3 || sal_index === 13 || sal_index === 23 ? sal4Color 
 : sal_index === 4 || sal_index === 14 || sal_index === 24 ? sal5Color
 : sal_index === 5 || sal_index === 15 || sal_index === 25 ? sal6Color 
 : sal_index === 6 || sal_index === 16 || sal_index === 26 ? sal7Color 
 : sal_index === 7 || sal_index === 17 || sal_index === 27 ? sal8Color 
 : sal_index === 8 || sal_index === 18 || sal_index === 28 ? sal9Color 
 : sal_index === 9 || sal_index === 19 || sal_index === 29? sal10Color : ''

  event.index = sal_index  //overriding the index of existing with dragged
   e.target.style.background = event.movieLength === false ? `linear-gradient(to right,  ${bgColor}, transparent)` : bgColor

   return event
 }


let updateProgram =  ProgrammedEvents.map((pro) => {
      let refNo = pro.ref_No
      let eventNo = pro.event_No
      let draggedNo = dragProgrammed === true && theDraggedElm.event_No
    
  if(eventNo === draggedNo && pro.name === theDraggedElm.name && refNo === theDraggedElm.ref_No ) {
    return {...pro, index: theDraggedElm.index,sal :numberOfSal[theDraggedElm.index].name, start: theDraggedElm.start, end:theDraggedElm.end,  }
  }
  return pro
  
  })
 

// generating programmed div which is shown in the table
function programmedFilms() {
      let pf = []
      //  let the = updatePro?.length ? updatePro : updateProgram 
       updateProgram.forEach( (event) => {
        let bgColor = event.index === 0 || event.index === 10 || event.index === 20 ? sal1Color
        : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color 
        : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color 
        : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color 
        : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color 
        : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color 
        : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color 
        : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color 
        : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color 
        : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color  : ''
        pf.push( 
          <div onMouseDown={ (e) => divClicked (e, event)} draggable={ modalOpen === false  ? 'true': 'false'} id={event.id} 
          onDrag={(e) => dragExisting(e,event)} 
          onDragStart={(e) => draggingDiv(e)} 
            style={{position:'absolute',top:`${event.y_axis}px`,left:`${event.x_axis}px`,width:`${(pixelWidthPerMin*event.length).toString().split(".")[0] + 'px' }`, 
            background:event.movieLength === false ? `linear-gradient(to right,  ${bgColor}, 40%, transparent)` :bgColor,
             border:event.eventObject.DeleteEvent === 1 ? '1px solid red' : '',borderRadius:'4px'
            }}>
             
            <FilmWidget all_events={copied_events} daysEvent={updateProgram} eventEdited={eventsEdit.find(e => { return e.No === event.event_No})}  arrtypename={event.ArrTypeName} film={event.name} 
            salNr={event.sal} eventsEdit={events_today}  event_no={event.event_No > 0 ? event.event_No : event.ref_No} ref_no ={event.ref_No}
             saveEditBtn={saveFilmEdit} theWidth={(pixelWidthPerMin*event.length).toString().split(".")[0]} 
             theEvent={event}  editedevent={editedEvents.find(e => {return e.event_No === event.event_No})}
              price={event.priceGroups?.length === 1 ?  event.priceGroups[0]?.Price : event.priceGroups?.length === 2 ? event.priceGroups[0].Price +'-'+  event.priceGroups[1].Price: '0'}  theDraggedElm={theDraggedElm} dragging={dragging}
              adTrailer = {event.eventObject.AdvertisementTrailer}
              movieLength={event.length}
              webresinfo={event.webReserveInfo} 
              webbuyinfo={event.webbuyInfo} 
              webshowinfo={event.webshowInfo} 
              buyenabled={event.buyEnabled} 
              resenabled={event.reserveEnabled} 
              numbered={event.numberedSeats}
              internetOrderAll={saveFilmEdit  && internetorderflag } 
              internetSellAll ={saveFilmEdit  && internetsellflag } 
              internetShowAll ={saveFilmEdit  && intershowflag} 
              ticketSellAll   ={saveFilmEdit  && sellticketflag}
              ticketOrderAll  ={saveFilmEdit  && orderticketflag} 
              end_Time={event.end} start_Time={event.start}  
              movieNameColor={    
                  event.index === 0 || event.index === 10 || event.index === 20 ? '#46484c' 
                : event.index === 1 || event.index === 11 || event.index === 21 ? '#fff'
                : event.index === 2 || event.index === 12 || event.index === 22 ? '#fff' 
                : event.index === 3 || event.index === 13 || event.index === 23 ? '#46484c'
                : event.index === 4 || event.index === 14 || event.index === 24 ? '#46484c' 
                : event.index === 5 || event.index === 15 || event.index === 25 ? '#fff' 
                : event.index === 6 || event.index === 16 || event.index === 26 ? '#fff' 
                : event.index === 7 || event.index === 17 || event.index === 27 ? '#46484c' 
                : event.index === 8 || event.index === 18 || event.index === 28 ? '#fff' 
                : event.index === 9 || event.index === 19 || event.index === 29 ? '#fff' :  ''}
            showTime={showTime && startTime}
            extendedBackColor= 
            {   event.index === 0 || event.index === 10 || event.index === 20 ? sal1Color2 
              : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color2
              : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color2 
              : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color2 
              : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color2 
              : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color2 
              : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color2 
              : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color2 
              : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color2 
              : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color2 :  ''} 

            timelineBackColor = {
               event.index === 0 || event.index === 10  || event.index === 20 ? sal1Color
             : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color 
             : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color 
             : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color 
             : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color 
             : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color 
             : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color 
             : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color 
             : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color 
             : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color  : '' 
            }

            priceDivBackColor={
                event.index === 0 || event.index === 10 || event.index === 20 ? sal1Color3 
              : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color3 
              : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color3 
              : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color3 
              : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color3 
              : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color3 
              : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color3 
              : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color3 
              : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color3 
              : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color3  : '' }

              activeColor={
                  event.index === 0 || event.index === 10 || event.index === 20 ? aktivColor1
                : event.index === 1 || event.index === 11 || event.index === 21 ? aktivColor2 
                : event.index === 2 || event.index === 12 || event.index === 22 ? aktivColor3
                : event.index === 3 || event.index === 13 || event.index === 23 ? aktivColor4
                : event.index === 4 || event.index === 14 || event.index === 24 ? aktivColor5
                : event.index === 5 || event.index === 15 || event.index === 25 ? aktivColor6
                : event.index === 6 || event.index === 16 || event.index === 26 ? aktivColor7
                : event.index === 7 || event.index === 17 || event.index === 27 ? aktivColor8
                : event.index === 8 || event.index === 18 || event.index === 28 ? aktivColor9
                : event.index === 9 || event.index === 19 || event.index === 29 ? aktivColor10  : ''
              }

              popupbg2={
                  event.index === 0 || event.index === 10 || event.index === 20 ? sal1popbg2
                : event.index === 1 || event.index === 11 || event.index === 21 ? sal2popbg2 
                : event.index === 2 || event.index === 12 || event.index === 22 ? sal3popbg2
                : event.index === 3 || event.index === 13 || event.index === 23 ? sal4popbg2
                : event.index === 4 || event.index === 14 || event.index === 24 ? sal5popbg2
                : event.index === 5 || event.index === 15 || event.index === 25 ? sal6popbg2
                : event.index === 6 || event.index === 16 || event.index === 26 ? sal7popbg2
                : event.index === 7 || event.index === 17 || event.index === 27 ? sal8popbg2
                : event.index === 8 || event.index === 18 || event.index === 28 ? sal9popbg2
                : event.index === 9 || event.index === 19 || event.index === 29 ? sal10popbg2  : ''
              }

              popupbg3 = {
                  event.index === 0 || event.index === 10 || event.index === 20 ? sal1popbg3
                : event.index === 1 || event.index === 11 || event.index === 21 ? sal2popbg3
                : event.index === 2 || event.index === 12 || event.index === 22 ? sal3popbg3
                : event.index === 3 || event.index === 13 || event.index === 23 ? sal4popbg3
                : event.index === 4 || event.index === 14 || event.index === 24 ? sal5popbg3
                : event.index === 5 || event.index === 15 || event.index === 25 ? sal6popbg3
                : event.index === 6 || event.index === 16 || event.index === 26 ? sal7popbg3
                : event.index === 7 || event.index === 17 || event.index === 27 ? sal8popbg3
                : event.index === 8 || event.index === 18 || event.index === 28 ? sal9popbg3
                : event.index === 9 || event.index === 19 || event.index === 29 ? sal10popbg3  : ''
              }

            /> 
               
            
           </div>
        ) 
      })
      return pf
}

const program = programmedFilms()

useEffect(() => {
   setCopyChosen(false)
   setEditChosen(false)  
},[selectedDate])


useEffect(() => {
  setError(false)
},[orgSelect])


const totalTableHeight = allMovies.length && document.getElementById('program_table')?.getBoundingClientRect().height

const leftMargin = allMovies.length && document.getElementById('tes').getBoundingClientRect().x
setLeftMargin(Math.round(leftMargin)+'px')

const [modalShow, setModalShow] = useState(false);




useEffect(() => { 
  if(eventSaveObj) { 
    
     eventSaveObj.PriceGroups.forEach(item => {
      if (item.Price === 0) {
      
        setEventErrorModal(true)
        setZeroPriceError('Vær opmærksom på at forestillingsprisen er 0 kr.')
      }
    });
    const ticketTypes = eventSaveObj.TicketTypes_Add?.length  ? [...eventSaveObj.TicketTypes,  ...eventSaveObj.TicketTypes_Add] : [...eventSaveObj.TicketTypes]
    const merged_ticketypes = ticketTypes.filter(
          item => !eventSaveObj.TicketTypes_Remove?.some(obj => obj.id === item.id)
          );
   
    if( merged_ticketypes.length > 0 ) {
      let tickets_with_default = []

           allTicketTypes.map((at) => {
                 merged_ticketypes.map((t) => {
                   if(t.No === at.No && at.Default === 1) {
                  
                     tickets_with_default.push(at)
                   }
                 })
               })
            
              if(tickets_with_default.length === 0) {
              
                 setEventErrorModal(true)
                 setManEventErrortext('Der er ikke valgt en primær billettype, så denne forestilling kan ikke gemmes i billetsystem, før det er rettet.')
                 }
              else if(tickets_with_default.length > 1) {
               
                setEventErrorModal(true)
                setManEventErrortext('Der er valgt flere primære billettyper, så denne forestilling kan ikke gemmes i billetsystem, før det er rettet.')
                  }
              else {
                
              }
   }

}
}, [eventSaveObj,allTicketTypes]);



  return (
    <main  programactive='active'  style={{width:'1920px', position:'relative',margin:'auto'}}  >
     
      {
        commitModal === true ? 
       <CommitModal  changesMax={changesMax} count={comitCount} windowHeight={windowHeight} leftMargin={leftMargin} changesLeft={changesLeft}/>
        : null
      }
      <ManEventErrorModal shown={eventErrorModal} errorText={manEventErrortext} zeroPriceError={zeroPriceError}/>
      <NoteModal shown={copyChosen}/>
      <WaitingModal  shown= {waitingModal}/>  
      <Header programActive='active'/>
     

          <section id='tes' className={'programContainer'}
           style={{display:'grid', gridTemplateColumns: showFilm ? 'auto 62px ' : 'auto 62px',height:totalTableHeight+300+'px'}}>
            
               <div className='programContainer_main'>
                <div style={{display:'flex',justifyContent:'space-between'}}>
                <OrgSelect />
                <button className='saveBtn' onClick={saveAllInSystem}>GEM ALLE DAGES RETTELSER I BILLETSYSTEM </button>
                </div>
              
        <GroupEditModal
        shown={modalShown}  data={grpEditArr} all_events={copied_events}
        close={() => {
          toggleModal(false);
        }}
      >
      </GroupEditModal>
      
      

<div style={{width:'58%',display:'flex',justifyContent:'space-between',border:'1px '}}>

  <p className='program_title lato-semibold'>Programlægning</p>
 
  <DatePicker />
  
</div>

<div  style={{display:'flex', justifyContent:'space-between',marginTop:'10px',marginRight:'4px'}}>
  <div>
    <button className='daysBtn'> DAGSVISNING</button>
    <button className='weeksBtn'>UGEVISNING </button>
  </div>


  <div style={{display:'flex',position:'relative',right:'-2px'}}>
    <button className='markAllBtn' onClick={handleSelectAll}>MARKER ALLE</button>
    {copyChosen ? <section style={{zIndex:100}}>
      <div className='editBtn' style={{display:'flex'}}>
      <button style={{width:'90px',color:'#982f2f',textDecoration:'underline', fontWeight:'bold'}} onClick={cancelCopy }>ANNULLER</button> 
       <p style={{width:'1px',backgroundColor:'#982f2f',height:'39px'}}></p>
       <button style={{width:'80px',color:'#982f2f',textDecoration:'underline',fontWeight:'bold'}} onClick={saveCopy}>KOPIER</button>
      </div>
      <div className='copyDiv'>
        <p style={{color:'#46484c',fontWeight:'600',paddingLeft:'5px',marginBottom:'5px'}}>Kopier valgte</p>
        <div style={{border: startDatoCal ? '1px solid #982f2f' : '',backgroundColor:'#fff',width:'155px',height:'43px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px'}}>
           <div style={{}}>
               <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold'}}>Startdato:</p> 
               <p style={{fontSize:'12px', color:'#46484c',marginTop:'-20px'}}>{start_dato}</p> 
           </div>
           <button style={{marginTop:'-4px'}} onClick={handleStartDatoCal}><img src={calendar} alt="" /></button>        
        </div>
        <div style={{border: endDatoCal || dateError ? '1px solid #982f2f' : '',backgroundColor:'#fff',width:'155px',height:'43px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',marginTop:'2px',}}>
           <div>
               <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold'}}>Slutdato:</p> 
               <p style={{fontSize:'12px', color:'#46484c',marginTop:'-20px'}}> { end_dato  }</p> 
           </div>
           <button style={{marginTop:'-4px'}} onClick={handleEndDatoCal}><img src={calendar} alt="" /></button>        
        </div>
      </div>
    </section>
    : 
    <button className='copyBtn' onClick={handleCopy}>  
     KOPIER VALGTE
    </button>
    }
    {startDatoCal ? (
    <div className='startDatoCal'>
        <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',justifyContent:'space-between',margin:'4px',}}>
           <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Startdato</p>
           <button><img src={iconCross} alt="" onClick={handleStartDatoCal}/></button>
        </div>
        <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
        <DayPicker 
         month={month} 
            onMonthChange={setMonth}  locale={da} mode="single" ISOWeek  showOutsideDays  showWeekNumber selected= {startDate}captionLayout="dropdown" fromYear={2022} toYear={2030} onSelect={setStartDate} onDayClick={handleStartDatoCal}  disabled={disabledDays}/>
    </div>
  ) : ''}

   {endDatoCal ? (
    <div className='endDatoCal'>
        <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',   justifyContent:'space-between',margin:'4px',}}>
           <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Slutdato</p>
           <button onClick={asFirstDate} style={{fontSize:'12px', textDecoration:'underline',color:'grey',}}>Vælg samme som startdato</button>
           <button><img src={iconCross} alt="" onClick={handleEndDatoCal}/></button>
        </div>
        <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
        </div>
        <DayPicker  month={month} 
            onMonthChange={setMonth}  mode="single" showOutsideDays  showWeekNumber 
            selected= {endDate} captionLayout="dropdown" fromYear={2022} toYear={2030}  ISOWeek
            onDayClick={handleEndDatoCal} onSelect={setEndDate}   
            disabled={disabledDays}/>
    </div>
  ) : ''}

    <button className='deleteBtn' onClick={deleteEvent}> SLET VALGTE</button>
    <button className='deleteBtn' onClick={deleteGhostEvent}> FORTRYLD VALGTE REDIGERING</button>

    {editChosen ?
    <section >
    <div className='editBtn' style={{display:'flex',zIndex: editChosen === true && modalShown === false ? 15: 2,position:'relative'}}>
       <button style={{width:'100px',color:'#982f2f',textDecoration:'underline',fontWeight:'bold'}} onClick={deleteTheEdit}>ANNULLER</button> 
       <p style={{width:'1px',backgroundColor:'#982f2f',height:'39px'}}></p>
       <button style={{width:'60px',color:'#982f2f',textDecoration:'underline',fontWeight:'bold'}} 
       onClick={saveTheEdit}>GEM</button>
    </div>
    <div className='editDiv' style={{zIndex: editChosen === true && modalShown === false  ? 15: 2}}>
       <div style={{paddingLeft:'10px'}}>
           <p style={{color:'#46484c',fontWeight:'600'}}>Rediger valgte</p>

           <div style={{marginTop:'-5px'}}>
               <div style={{display:'flex',marginTop:'0px',border:'1px  ',height:'14px',marginBottom:'5px',justifyContent:'space-between',width:'145px',position:'relative'}}>
                {internetorderflag === 2 ? <img onClick={handleInternetOrder2} src= {interOrder2 == 0 ? small_checkmark : interOrder2 === 1 ? small_square : semiCheckbox }  alt=""  /> 
                : 
               <img onClick={handleInternetOrder} src= { interOrder === true ?  small_checkmark:small_square }  alt=""  />
                }
                 <p style={{fontSize:'12px',color:'#46484c',marginTop:'-3px',marginLeft: '-18px'}}>Internetbestilling </p>
                {interorderChanged === true ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px  ',justifyContent:'space-between',width:'145px',position:'relative'}} >
               {internetsellflag === 2 ?  
               <img onClick={handleInternetSell2} src= {interSalg2 === 0 ? small_checkmark : interSalg2 === 1 ? small_square : semiCheckbox  }  alt=""  />
               : 
               <img onClick={handleInternetSell} src= { interSalg === true ?  small_checkmark : small_square }  alt=""  />}
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'-42px',color:'#46484c'}}>Internet salg</p>
                 {intersalgChanged === true  ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }

               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px ',justifyContent:'space-between',width:'145px',position:'relative'}} >
               { intershowflag === 2 ?  <img onClick={handleInternetShow2} src= {interShow2 === 0 ? small_checkmark : interShow2 === 1 ? small_square :   semiCheckbox }  alt=""  />  : 
                 <img onClick={handleInternetShow} src= { interShow === true ?  small_checkmark  :small_square }  alt=""  />   
                }        
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'-45px',color:'#46484c'}}>Intervisning</p>
                 {intershowChanged === true   ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px  ',justifyContent:'space-between',width:'145px',position:'relative'}} >
               {sellticketflag === 2 ?   
                <img onClick={handleTicketSell2} src= {buyEnabled2 === 0 ? small_checkmark : buyEnabled2 === 1 ? small_square : semiCheckbox }  alt=""  /> : 
               <img  onClick={handleTicketSell} src= { buyEnabled === true?  small_checkmark  : small_square }  alt=""  />
              }
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'-32px',color:'#46484c'}}>Salg i billetsalg</p>
                 {buyChanged === true ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px ',justifyContent:'space-between',width:'145px',position:'relative'}} >
               {orderticketflag === 2 ?
               <img onClick={handleTicketSellOrder2} src= {resEnabled2 === 0 ? small_checkmark : resEnabled2 === 1 ? small_square :  semiCheckbox }  alt=""  />  : 
               <img onClick={handleTicketSellOrder} src= { resEnabled === true ?  small_checkmark :small_square }  alt=""  />
              }
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'-5px',color:'#46484c'}}>Bestilling i billetsalg</p>
                 {resChanged === true ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

           </div>
          
       </div>
       <div style={{border:'1px ',backgroundColor:'#dde6f0',marginTop:'15px',paddingLeft:'10px',paddingTop:'4px',borderTopLeftRadius:'6px', borderTopRightRadius:'6px'}}>
               <p style={{margin:0,fontSize:'12px',color:'#46484c'}}>Prisgrupper</p>
               <p style={{margin:0,fontSize:'12px',color:'#46484c'}}>Billettyper</p>
               <p style={{margin:0,fontSize:'12px',color:'#46484c',paddingBottom:'3px'}}>Forestillingstype</p>
           </div>
           
           <div style={{backgroundColor:'#dde6f0',marginTop:'1px',borderBottomLeftRadius:'6px',borderBottomRightRadius:'6px',paddingLeft:'3px',height:'30px'}}>
            <button style={{fontSize:'12px',color:'#46484c',textDecoration:'underline'}} 
            onClick={() => { 
              toggleModal(!modalShown);
               handleGroupEdit() }}>REDIGER</button>
           </div>
    </div>
        <EditChosenBox shown={editChosen} modalshown={modalShown}/>
    </section>
        :
        <button className='editBtn' onClick={handleEdit}> REDIGER VALGTE </button>
   }
   <button className='deleteBtn' onClick={saveChosenInSystem}> GEM VALGTE I BILLETSYSTEM</button>
  </div>
</div>

<br />
<br />
{ showErrorModal === true ? 
<ErrorModal shown={showErrorModal} errorStatus={errorStatus} errorType={errorType}
 errorNo={errorNo} errorText={errorText}/>
: ''}

 { orgSelect && <ScaleLoader color="#982f2f" loading={isloading} height={100}  cssOverride={override}/>
 } 

{error ? 'kunne ikke vise forestillinger ' : 
<>

<div  className='salContainer' style={{height:numberOfSal.length*48+'px'}}>
  {numberOfSal.sort(function (a,b) { 
       if (a.UseSeats !== b.UseSeats) {
        return b.UseSeats - a.UseSeats
     }
     if (a.name === b.name) {
      return 0;
     }
     return a.name > b.name ? 1 : -1
      } ).map((sal) => (
    <p key={sal.No} className='sal' >{sal.name}</p>
  ))}
   
</div>


 
             
     <div style={{border:'1px ',height: '400px', width:'100%',   padding: '0', position:'relative'}}   onDragOver={(e) => handleDragOver(e)} onDrop={(e)=> {handleOnDrop(e)}} >
    
   {allEvents.length ?   <p className='twelve' style={{backgroundColor:modalShown?'':'#fff',paddingTop:'0px',color:modalShown?'#524f4f':'#8d8d8d'}}>  
            <span className='twelve' style={{color:'#8d8d8d'}}>{te}:00</span> 
             </p> 
           : ''  }
     <table className='table table-bordered'   id="program_table" style={{width:'1698px'}}>
      { isloading === false && 
      <>
        <thead id='t_head'>
          <tr style={{height:'52px',borderTop:'3px solid #dee0e3',borderBottom:'3px solid #dee0e3',}}>
          {timeStamp.map((t, i) => (
                 <td  key={i} className='formattedTD' style={{position:'relative',borderLeft: t[0] ? '1px solid lightgrey' : ''}}>
                     <span style={{position:'absolute',top:'13px',left:'-21px'}}>{t == '24' ? '00' : t}:00</span>
                </td>
          )
          )}                      
          </tr>      
        </thead>
             
       </>
    }
      <tbody id='t_body' >
        {numberOfSal.map((sal,index) => (
         <tr style={{height:'48px',}}>
           {timeStamp.map((t,i) => (
            <td key={i} style={{borderLeft: t[0] ? '1px solid lightgrey' : ''}}></td>
           ))}         
         </tr>        
        ))}     
      </tbody>
 
     {showG === true ?
    
      <div  style={{position:'absolute',top:`${y}px`,left:`${x}px`,height:'45px',  color:'white' }}> 
        <span style={{position:'absolute', top:'-15px',fontSize:'12px',color:'#46484c'}}>{moment(startTime).format('HH:mm')}</span>
      <div style={{height:'43px', 
      background:newDraggedFilm.length === 0 ? 'linear-gradient(to right, #982f2f, transparent)': '#982f2f',
      width:`${(pixelWidthPerMin*filmWidth).toString().split(".")[0] + 'px'}`,zIndex:9 ,padding:'10px',color:'white' }}>{draggedFilm}</div>     
      </div>     
       : ''
        }  
 
   
    {program}
     

     </table>
    
                </div> 
                </>
              }

           </div>
      { showFilm === false ?
               <aside className='programContainer_aside' style={{height:totalTableHeight+300+'px'}}>
                 <p className='choose' >Vælg</p>
                 <p className='film'>film</p>
                 <div className='vector'></div>
                 <div className='doubleArrows' style={{marginTop:'30vh'}} onClick={handleShowFilm}>
                    <img src={doublearrow} alt="" />
                 </div>
               
               </aside> : ''
                }
          </section>
          <div id='t'  style={{display: showFilm ? 'grid' : 'none', gridTemplateColumns: showFilm ? '1fr 1fr' : '',marginTop:'1px'}} className='chooseFilmContainer' >
          <aside className='programContainer_aside' >
                 
               <div className='vector'></div>
               <div  style={{marginTop:'42vh', transform:'rotate(180deg)',marginRight:'12px'}} onClick={handleShowFilm}>

                    <img src={doublearrow} alt="" />
                 
               </div>
               
               </aside>
                <div style={{ width:'338px',paddingLeft:'30px'}}>
                  <button style={{float:'right',border:'none', background:'none'}} onClick={handleShowFilm}>
                  <img src={close} alt='close'/> </button>
                  <br />
                  <br />
                  <br />
                <p className='choose_film' >Vælg film</p>
               
                <div style={{position:'relative',marginTop:'25px'}}>
                <input  className='search_film' placeholder='Søg efter film'  value={q}
                            onChange={(e) => setQ(e.target.value)}/> 

                  <span style={{position:'absolute', top:'7px',left:'10px'}}>
                  <img src={searchIcon} alt='search' height='20px'/></span>

                </div>

                <label htmlFor="" style={{margin:'20px 6px',display:'flex',position:'relative'}}>
                <input style= {{outline:searchPrecise ? '1px solid grey' : ''}}type='checkbox' checked={searchPrecise} onChange={handlePreciseSearch}/> 
                <span style={{color:'#46484c',position:'absolute',top:'-6px',left:'25px'}}>Slå søgning fra, indtast eksakt titel</span> 
                </label>
                
              
               
                <div className='image_container'>
                   {search(data).filter((a,b) => { return a.name !== b.name}).map((movie,i) => (
                     <div draggable onDragEnd={(e) => imgDragEnd(e)}  className='imgCont'  onDragStart=   {(e) => handleOnDrag(e,movie.name,movie)} >
                    <img   src={`https://ebillet.dk/poster/`+movie.poster.large} id={i} name={movie.name} duration={movie.length} movieno={movie.No} alt={movie.name} width='125px' height='185px' />  
                    <span className='tooltiptext'>{movie.name}</span>                      
                    </div>
                    ))}               
                </div> 
     
            </div>
          </div>
      </main>
  )
}

export default Program